///////////////////////////////////////////////////

import { limitOrderFormApiConnector } from 'apiConnector/secondary-market/limit-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { limitOrderOriginalFormActions } from 'state/secondaryMarket/limit-order/form/original/original.actions';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';

export function loadLimitOrderToAmendEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getOrderById } = limitOrderFormApiConnector(httpClient);
    return actions$.pipe(
      ofType('SECONDARY_MARKET_AMEND_LIMIT_ORDER_FETCH_REQUESTED'),
      mergeMap(({ orderId, tabId }) =>
        getOrderById(orderId).pipe(
          map(response => limitOrderThunks.amendFetchedThunk(tabId, orderId, response)),
          catchError((err: Error) =>
            of(limitOrderOriginalFormActions.secondaryMarketAmendFetchFailed(tabId, err?.message)),
          ),
        ),
      ),
    );
  };
}
